import { useMutation, useQueryClient } from "@tanstack/react-query";

import { duplicateCropExplorationEntry, duplicateCropExplorationTemplateEntry } from "services";

import { DUPLICATE_CROP_EXPLORATION_ENTRY, GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES } from "consts";

export const useDuplicateCropExplorationEntry = (isAdmin: boolean = false) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DUPLICATE_CROP_EXPLORATION_ENTRY],
    mutationFn: !isAdmin ? duplicateCropExplorationEntry : duplicateCropExplorationTemplateEntry,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES] });
    },
  });
};
